function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bitbucket-file-artifact_svg__a",
  x1: 64.01,
  y1: 30.27,
  x2: 32.99,
  y2: 54.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#0052cc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2684ff"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M24.7 43.51h13.05l3.15-18.39H21.23l3.47 18.39z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 6.26a2 2 0 00-2 2.32l8.49 51.54a2.72 2.72 0 002.66 2.27h40.73a2 2 0 002-1.68l8.49-52.12a2 2 0 00-2-2.32zm35.75 37.25h-13l-3.52-18.39H40.9z",
  fill: "#2684ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.67 25.12H40.9l-3.15 18.39h-13L9.4 61.73a2.71 2.71 0 001.75.66h40.74a2 2 0 002-1.68z",
  fill: "url(#bitbucket-file-artifact_svg__a)"
}));

function SvgBitbucketFileArtifact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 63.27"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "bitbucket-file-artifact.e6943.svg";
export { SvgBitbucketFileArtifact as ReactComponent };